import { defineMessages } from 'react-intl';

const messages = defineMessages({
  off: {
    id: 'conversionBanner.off',
    defaultMessage: 'Play Your Favorite Songs + Score 10% Off Fender.',
  },
  button: {
    id: 'conversionBanner.button',
    defaultMessage: 'start your free trial',
  },
  cancelled: {
    id: 'conversionBanner.cancelled',
    defaultMessage: 'restart now',
  },
});

export default messages;
